import Vue from 'vue';

import messagebox from '../components/public/messagebox.js';

Vue.use(messagebox);
